// extracted by mini-css-extract-plugin
export var container = "_55-0";
export var icon = "_55-1";
export var text = "_55-2";